// Passkey step-up prompt singleton (same shape as twoFactorPrompt). The API
// client calls request() when the server answers 403 PASSKEY_REQUIRED; the one
// mounted <PasskeyPromptModal/> subscribes, runs the passkey ceremony and
// calls resolve() (verified) or reject() (cancelled / unsupported).
// Concurrent requests share ONE prompt.
let pending = null;          // { promise, resolve, reject }
let listener = null;

const notify = (open) => { if (listener) listener(open); };

export const passkeyPrompt = {
  request() {
    if (pending) return pending.promise;
    let res; let rej;
    const promise = new Promise((resolve, reject) => { res = resolve; rej = reject; });
    pending = { promise, resolve: res, reject: rej };
    notify(true);
    return promise;
  },
  subscribe(fn) {
    listener = fn;
    if (pending) fn(true);
    return () => { if (listener === fn) listener = null; };
  },
  resolve() {
    const p = pending; pending = null;
    notify(false);
    if (p) p.resolve();
  },
  reject(reason) {
    const p = pending; pending = null;
    notify(false);
    if (p) p.reject(reason || new Error('Passkey confirmation cancelled'));
  },
};

export default passkeyPrompt;
